// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import Loader from 'components/atoms/Loader';
import { useToast } from 'hooks';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import FileAttachment from './CommonAttachment/FileAttachment';
import { ImageAttachment } from './CommonAttachment/ImageAttachment';
import AttachmentInput from './AttachmentInput';
import { useNoteAndAttachmentFieldStyles } from './styles';
import { onSuccess, onFailure, attachmentHandler } from './AttachmentUtils';
import useAttachment from './hooks/useAttachment';

const UploadAttachments = ({
  inputId,
  attachmentTitle,
  imageFileAttachment,
  setImageFileAttachment,
  field,
  handleDirty,
}) => {
  const {
    attachmentLoading,
    saveAttachment,
    fetchAttachmentData,
    stripPrefixInAttachmentID,
    getFormData,
  } = useAttachment();

  const attachmentId = field?.attachments?.map((item) => {
    const { id } = item;
    return stripPrefixInAttachmentID(id);
  });

  const answerAttachmentId = field?.answer?.map((item) => {
    const { id } = item;
    return stripPrefixInAttachmentID(id);
  });

  const [{ mode }, { setAttachments, setAnswer }] = useCustomForm();
  const toast = useToast();
  const [values, setValues] = useState('');
  const classes = useNoteAndAttachmentFieldStyles();

  const handleSuccess = (data) => {
    onSuccess(data, setImageFileAttachment);
  };
  const handleFailure = (err) => onFailure(err, setValues);

  const handleAttachment = (e) => {
    const files = e.target.files;

    const isFileNameTooLong = Array.from(files).some(
      (file) => file.name?.length > 100,
    );

    if (isFileNameTooLong) {
      toast.error('File name should not exceed 100 characters.');
      return;
    }

    const isFileSizeExceeded = Array.from(files).some(
      (file) => file.size > 25 * 1024 * 1024,
    );

    if (isFileSizeExceeded) {
      toast.error('File size should not exceed 25MB.');
      return;
    }

    attachmentHandler(
      e.target.files,
      saveAttachment,
      getFormData,
      handleSuccess,
      handleFailure,
    );

    if (mode === 'add' || mode === 'edit') handleDirty();
  };

  // Fetch attachment data on first render
  const firstRender = useRef(true);
  const hasFetchedData = useRef(false);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (
      (attachmentId?.length || answerAttachmentId?.length) &&
      !hasFetchedData.current
    ) {
      fetchAttachmentData({
        query: { attachments: attachmentId || answerAttachmentId },
        skip: false,
        onSuccess: (res) => {
          const newAttachmentData = res;
          const formattedAttachments = Object.keys(newAttachmentData).map(
            (itemId) => ({
              id: itemId,
              ...newAttachmentData[itemId],
              attach_to_pdf:
                imageFileAttachment.find(
                  (attachment) => attachment.id === itemId,
                )?.attach_to_pdf || false,
            }),
          );

          setImageFileAttachment(formattedAttachments);
        },
      });
      hasFetchedData.current = true;
    }
  }, [attachmentId]);

  useEffect(() => {
    if (field?.type === 'instruction') {
      setAttachments(inputId, imageFileAttachment);
    }

    if (field?.type === 'files') {
      setAnswer(inputId, imageFileAttachment);
    }
  }, [imageFileAttachment]);

  return (
    <Box>
      <AttachmentInput
        classes={classes}
        attachmentHandler={handleAttachment}
        values={values}
        setValues={setValues}
        inputId={inputId}
        attachmentTitle={attachmentTitle}
        attachmentLoading={attachmentLoading}
      />
      {attachmentLoading ? (
        <Loader />
      ) : (
        <Box className={classes.multiAttachmentContainer}>
          <FileAttachment
            setFileAttach={setImageFileAttachment}
            fileAttach={imageFileAttachment}
            handleDirty={handleDirty}
            field={field}
          />

          <ImageAttachment
            setImageAttach={setImageFileAttachment}
            imageAttach={imageFileAttachment}
            handleDirty={handleDirty}
          />
        </Box>
      )}
    </Box>
  );
};

export default UploadAttachments;
